import { connect } from 'react-redux';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { fetchHomepage } from 'client/store/homepage/thunks';
import { fetchEvents } from 'client/store/event/thunks';
import { isLoading, getHomepage } from 'client/store/homepage/selectors';
import { isLoading as isEventsLoading, getEvents } from 'client/store/event/selectors';
import { getFiltersFromQuery, getQueryValue } from 'client/components/filters/filters-query';
import { ServerFetchDataProps, ConnectedComponent } from 'client/types/common';
import { State } from 'client/store';
import HomePage, { DispatchProps, StateProps } from './home';

const urlPropsQueryConfig = {
    q: { type: UrlQueryParamTypes.string }
};

const mapStateToProps = (state: State): StateProps => ({
    data: getHomepage(state),
    isLoading: isLoading(state),
    isEventsLoading: isEventsLoading(state),
    events: getEvents(state)
});

const mapDispatchToProps = {
    fetchHomepage,
    fetchEvents
};

const component = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(addUrlProps({ urlPropsQueryConfig })(HomePage)) as ConnectedComponent<typeof HomePage, StateProps & DispatchProps>;

component.serverFetchData = ({ dispatch, location }: ServerFetchDataProps<null>) => {
    const query = getQueryValue(location.search);
    const { filters } = getFiltersFromQuery(query.q as string);

    return Promise.all([
        dispatch(fetchHomepage()),
        dispatch(fetchEvents({ filters }))
    ]);
};

export default component;
